import React from 'react';
import ReactDOM from 'react-dom';
import Root from './routing/Root';

ReactDOM.render(<Root />, document.getElementById('root'));
